import { Button } from "common-frontend-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrid2, faPencil } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface EmptyDashboardStateProps {
    isCustomizing: boolean;
    onStartCustomizing: () => void;
}

export function EmptyDashboardState({
    isCustomizing,
    onStartCustomizing,
}: EmptyDashboardStateProps) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[400px] text-center p-8">
            <div className="text-gray-400  mb-4">
                <FontAwesomeIcon icon={faGrid2} className="w-24 h-24 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2 text-gray-600 dark:text-gray-400">
                    {t("dashboard.noWidgetsSelected")}
                </h3>
                <p className="text-gray-500 dark:text-gray-500 mb-2">
                    {t("dashboard.clickEditToAddWidgets")}
                </p>
                <p className="text-gray-500 dark:text-gray-500 text-sm mb-6">
                    {t("dashboard.emptyAfterUpdateHint")}
                </p>
                {!isCustomizing && (
                    <Button
                        type="button"
                        variant="default"
                        onClick={onStartCustomizing}
                        className="hidden lg:inline-flex"
                    >
                        <FontAwesomeIcon icon={faPencil} className="mr-2" />
                        {t("dashboard.startCustomization")}
                    </Button>
                )}
            </div>
        </div>
    );
}
